require('./_wks-define')('asyncIterator');


/*****************
 ** WEBPACK FOOTER
 ** ./~/.2.4.1@core-js/library/modules/es7.symbol.async-iterator.js
 ** module id = 492
 ** module chunks = 0
 **/